import Icon from '@components/UI/Icon';
import css from '@utils/css';
import React from 'react';
import style from './StarsReview.module.css';

export default function StarsReview ({ className }) {

    return <>
        <div className={ css('flex items-center', className, style.main) }>
            <div className='paragraph paragraph_lg !text-green-900 font-[700] pr-2'>4.8</div>
            { [...Array(5).keys()].map(i => <Icon key={ i } name='fivePointedStar' color='yellow-700' size={ 24 }/>) }
            <div className={ css('paragraph paragraph_lg pl-4', style.review) }>(1974 reviews)</div>
        </div>
    </>;

}
